import { api } from '../../';
import { PrizeTypesData } from './types';

export const prizeTypesApi = api.enhanceEndpoints({ addTagTypes: ['PrizeTypes'] }).injectEndpoints({
  endpoints: build => ({
    getPrizeTypesList: build.query<PrizeTypesData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/reward-types?${queryString}`,
        method: 'GET',
      }),
    }),
    getPrizeTypesSimpleList: build.query<PrizeTypesData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/reward-types/simple-list?${queryString}`,
        method: 'GET',
      }),
    }),
    createPrizeTypes: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/reward-types`,
        method: 'POST',
        body,
      }),
    }),
    updatePrizeTypes: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/reward-types/${body.id}`,
        method: 'PATCH',
        body: body.data,
      }),
    }),
  }),
});

export const { useLazyGetPrizeTypesListQuery, useLazyGetPrizeTypesSimpleListQuery, useCreatePrizeTypesMutation, useUpdatePrizeTypesMutation } = prizeTypesApi;
